export default function linkPreviewPluginTrigger(evt, editor) {
    if (evt.eventType === 6 /* ContentChanged */) {
        var contentChangedEvent = evt;
        if ((contentChangedEvent.source === "AutoLink" /* AutoLink */ ||
            contentChangedEvent.source === "SetContent" /* SetContent */) &&
            editor
                .getContent(false /*triggerExtractContentEvent*/)
                .toLowerCase()
                .indexOf('<a ') >= 0) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=linkPreviewPluginTrigger.js.map